import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import Slider from "react-slick";

import "../style/slick.css";
import "../style/slick-theme.css";
import Loader from "./Loader";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  autoplay: true,
  slidesToShow: 1,
  fade: false,
  autoplaySpeed: 4000
  // fade: true
};

class ImageScroller extends Component {
  render() {
    return (
      <Container>
        {this.props.loading ? (
          <Loader padding="10px" />
        ) : (
          <SliderWrapper>
            <StyledSlider {...sliderSettings}>
              {this.props.images.map(value => {
                return (
                  <div key={value}>
                    <StyledSliderImageContainer
                      style={{
                        backgroundImage: "url(" + value + ")"
                      }}
                    />
                  </div>
                );
              })}
            </StyledSlider>
          </SliderWrapper>
        )}
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
`;

const SliderWrapper = styled.div`
  padding: 0;
  width: 100%;
  position: relative;
  @media only screen and (max-width: 960px) {
    padding-bottom: 0;
  }
`;

const StyledSlider = styled(Slider)`
  width: 100%;
  height: 300px;
  @media only screen and (max-width: 960px) {
    height: 180px;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const StyledSliderImageContainer = styled.div`
  width: 100%;
  background-size: cover;
  background-position: center;
  height: 300px;
  @media only screen and (max-width: 960px) {
    height: 180px;
  }
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

export default ImageScroller;



// WEBPACK FOOTER //
// ./src/components/ImageScroller.js